const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 128;

export interface LoginFormValues {
	email: string;
	password: string;
}

export type LoginFormFieldErrors = Partial<
	Record<keyof LoginFormValues, string>
>;

export function isValidLoginEmail(value: string): boolean {
	return EMAIL_PATTERN.test(value.trim());
}

export function validateLoginForm(
	values: LoginFormValues,
): LoginFormFieldErrors {
	const errors: LoginFormFieldErrors = {};
	const email = values.email.trim();
	const password = values.password;

	if (!email) {
		errors.email = "Email is required.";
	} else if (!isValidLoginEmail(email)) {
		errors.email = "Enter a valid email address.";
	}

	if (!password) {
		errors.password = "Password is required.";
	} else if (password.length < MIN_PASSWORD_LENGTH) {
		errors.password = `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
	} else if (password.length > MAX_PASSWORD_LENGTH) {
		errors.password = `Password must be at most ${MAX_PASSWORD_LENGTH} characters.`;
	}

	return errors;
}

export function hasLoginFormErrors(errors: LoginFormFieldErrors): boolean {
	return Object.keys(errors).length > 0;
}
